var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "structured-json-form" }, [
    _vm.isList
      ? _c(
          "div",
          { staticClass: "list-mode" },
          [
            _vm._l(_vm.internalListValue, function (item, index) {
              return _c(
                "div",
                { key: "item-" + index, staticClass: "list-item" },
                [
                  _c(
                    "div",
                    { staticClass: "item-header" },
                    [
                      _c("span", [_vm._v("#" + _vm._s(index + 1))]),
                      _vm._v(" "),
                      _c("a-button", {
                        attrs: {
                          type: "danger",
                          size: "small",
                          icon: "delete",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(index)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-body" },
                    _vm._l(_vm.schema, function (field) {
                      return _c(
                        "div",
                        { key: field.name, staticClass: "form-field mb-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "field-header" },
                            [
                              _c(
                                "label",
                                { class: { required: field.required } },
                                [_vm._v(_vm._s(field.label))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onFieldModeChange(
                                        index,
                                        field.name
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.fieldModes[index + "_" + field.name],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.fieldModes,
                                        index + "_" + field.name,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "fieldModes[`${index}_${field.name}`]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.fieldModes[index + "_" + field.name] === "static"
                            ? [
                                field.type === "text"
                                  ? _c("a-input", {
                                      attrs: {
                                        value: item[field.name],
                                        placeholder:
                                          field.description || field.label,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateItemField(
                                            index,
                                            field.name,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : field.type === "userid"
                                  ? _c(
                                      "a-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          value: item[field.name],
                                          allowClear: "",
                                          placeholder:
                                            field.description || "Select user",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.updateItemField(
                                              index,
                                              field.name,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      _vm._l(_vm.users, function (user) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: user._id,
                                            attrs: { value: user._id },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(user.name) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  : field.type === "contactid"
                                  ? _c("a-input", {
                                      attrs: {
                                        value: item[field.name],
                                        placeholder:
                                          field.description ||
                                          "Contact ID (örn: {{id}})",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateItemField(
                                            index,
                                            field.name,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : field.type === "chatid"
                                  ? _c("a-input", {
                                      attrs: {
                                        value: item[field.name],
                                        placeholder:
                                          field.description ||
                                          "Chat ID (örn: {{conversationId}})",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateItemField(
                                            index,
                                            field.name,
                                            $event.target.value
                                          )
                                        },
                                      },
                                    })
                                  : field.type === "number"
                                  ? _c("a-input-number", {
                                      staticStyle: { width: "100%" },
                                      attrs: { value: item[field.name] },
                                      on: {
                                        change: function ($event) {
                                          return _vm.updateItemField(
                                            index,
                                            field.name,
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : field.type === "boolean"
                                  ? _c(
                                      "div",
                                      [
                                        _c("a-switch", {
                                          attrs: { checked: item[field.name] },
                                          on: {
                                            change: function ($event) {
                                              return _vm.updateItemField(
                                                index,
                                                field.name,
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "ml-2" }, [
                                          _vm._v(
                                            _vm._s(
                                              item[field.name]
                                                ? "True"
                                                : "False"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : field.type === "array"
                                  ? _c("a-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: item[field.name],
                                        mode: "tags",
                                        placeholder:
                                          field.description || "Add items",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.updateItemField(
                                            index,
                                            field.name,
                                            $event
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            : [
                                _c("TiptapEditor", {
                                  attrs: {
                                    value: item[field.name],
                                    placeholder:
                                      field.description || "{{variable}}",
                                    rows: 1,
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.updateItemField(
                                        index,
                                        field.name,
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "dashed", block: "", icon: "plus" },
                on: { click: _vm.addItem },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.add") || "Add Item") +
                    "\n        "
                ),
              ]
            ),
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "object-mode" },
          _vm._l(_vm.schema, function (field) {
            return _c(
              "div",
              { key: field.name, staticClass: "form-field mb-3" },
              [
                _c(
                  "div",
                  { staticClass: "field-header mb-2" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "d-block",
                        class: { required: field.required },
                        staticStyle: { "font-weight": "500" },
                      },
                      [_vm._v(_vm._s(field.label))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-radio-group",
                      {
                        attrs: { "button-style": "solid", size: "small" },
                        on: {
                          change: function ($event) {
                            return _vm.onFieldModeChange(null, field.name)
                          },
                        },
                        model: {
                          value: _vm.fieldModes[field.name],
                          callback: function ($$v) {
                            _vm.$set(_vm.fieldModes, field.name, $$v)
                          },
                          expression: "fieldModes[field.name]",
                        },
                      },
                      [
                        _c("a-radio-button", { attrs: { value: "static" } }, [
                          _vm._v("Statik"),
                        ]),
                        _vm._v(" "),
                        _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                          _vm._v("Dinamik"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.fieldModes[field.name] === "static"
                  ? [
                      field.type === "text"
                        ? _c("a-input", {
                            attrs: {
                              value: _vm.internalObjectValue[field.name],
                              placeholder: field.description || field.label,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateObjectField(
                                  field.name,
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : field.type === "userid"
                        ? _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.internalObjectValue[field.name],
                                allowClear: "",
                                placeholder: field.description || "Select user",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.updateObjectField(
                                    field.name,
                                    $event
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.users, function (user) {
                              return _c(
                                "a-select-option",
                                { key: user._id, attrs: { value: user._id } },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(user.name) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : field.type === "contactid"
                        ? _c("a-input", {
                            attrs: {
                              value: _vm.internalObjectValue[field.name],
                              placeholder:
                                field.description || "Contact ID (örn: {{id}})",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateObjectField(
                                  field.name,
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : field.type === "chatid"
                        ? _c("a-input", {
                            attrs: {
                              value: _vm.internalObjectValue[field.name],
                              placeholder:
                                field.description ||
                                "Chat ID (örn: {{conversationId}})",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateObjectField(
                                  field.name,
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : field.type === "number"
                        ? _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.internalObjectValue[field.name],
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateObjectField(field.name, $event)
                              },
                            },
                          })
                        : field.type === "boolean"
                        ? _c(
                            "div",
                            [
                              _c("a-switch", {
                                attrs: {
                                  checked: _vm.internalObjectValue[field.name],
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.updateObjectField(
                                      field.name,
                                      $event
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.internalObjectValue[field.name]
                                      ? "True"
                                      : "False"
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : field.type === "array"
                        ? _c("a-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              value: _vm.internalObjectValue[field.name],
                              mode: "tags",
                              placeholder: field.description || "Add items",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateObjectField(field.name, $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  : [
                      _c("TiptapEditor", {
                        attrs: {
                          value: _vm.internalObjectValue[field.name],
                          placeholder: field.description || "{{variable}}",
                          rows: 1,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.updateObjectField(field.name, $event)
                          },
                        },
                      }),
                    ],
              ],
              2
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }